<template>
  <div v-if="tooltip" class="tooltip" :style="getStyles">
    <div class="tooltip__inner">
       <div class="tooltip__image">
          <img :src="tooltip.item.image" :alt="tooltip.item.wine">
       </div>
      <div class="tooltip__title" v-html="tooltip.item.wine"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { usePagesStore } from "@stores/pages";
import type { Props } from './model/index';
import {useWindowSize} from "@vueuse/core";

const { height: windowHeight } = useWindowSize();
defineOptions({
  name: 'AppTooltip'
})
const pagesStore = usePagesStore();
const tooltipHeight = 216;
const props = defineProps<Props>();
const topPercent = ((props.tooltip.y)/windowHeight.value)*100;
const tooltipPercent = (tooltipHeight/windowHeight.value)*100;
const getStyles = computed(()=>{
  return {top: (topPercent-tooltipPercent - 2)+'%', left: props.tooltip.x+ 'px'}
});
</script>

<style scoped lang="scss">
  .tooltip{
    position: absolute;
    z-index: 11000;
    &__inner{
      width: 183px;
      height: 216px;
      transform: translateX(-50%);
      background: var(--background-primary);
      border:1px solid var(--color-primary-ghost-30);
      border-radius: var(--border-radius-xs);

      background: var(--background-primary);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-between;
      padding: 16px;
    }
    &__image{
      img{
        height: 110px;
        object-fit: contain;
      }
    }
    &__title{
      white-space: normal;
      text-align: center;
      font-size: 12px;
      line-height: 14px;
    }
  }
</style>